import React, { useState, useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
// @material-ui/core components
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import {
  getMenus as getCategoryList,
  deleteMenuByadmin
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
const MenuTableList = (props) => {
  const classes = useStyles();
  useEffect(() => {
    props.getCategoryList(props.match.params.vendorId);
    setItemVendorId(props.match.params.vendorId);
  }, [update]);

  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [newVendorId, setItemVendorId] = useState(0);
  const [itemDelete, setItemDelete] = useState(0);

  const handleDelete = (vendorId, menuId) => {
    props.deleteMenuByadmin(vendorId, menuId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>All Menus</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Image</th>
            <th>Category</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.menuItems.length !== 0 ? (
            props.menuItems.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                <td>{item.name}</td>
                <td>
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{ height: '70px' }}
                  />
                </td>
                <td>Restaurant</td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Menu??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(newVendorId, itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a Menu</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(newVendorId, itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to="/admin/add-menu">
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  menuItems: state.admin.menuItems
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: (menuId) => dispatch(getCategoryList(menuId)),
    deleteMenuByadmin: (vendorId, menuId) =>
      dispatch(deleteMenuByadmin(vendorId, menuId))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(MenuTableList);
